import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import { v1 } from '@hc-frontend/services-lead-storage';

import type { UpdateProspectLeadIdRepository } from '../../domain';

export function updateProspectLeadIdAdapterFactory({
  baseURL,
}: {
  baseURL: string;
}): UpdateProspectLeadIdRepository {
  return {
    update: async ({
      userId,
      sessionId,
      domainSessionId,
      domainUserId,
      leadId,
      subProductType,
      trustedFormUrl,
    }) => {
      try {
        const payload: v1.UpdateProspectDto = {
          userId,
          sessionId,
          domainUserId,
          domainSessionId,
          tcpaUniversalId: leadId,
          subProductType,
          trustedFormUrl,
        };
        const response = await v1.updateProspectService(baseURL, payload);

        if (response.result !== 'success') {
          return createErrorOperationResult({
            errors: [
              {
                code: 'failedToUpdateProspectLeadId',
                rootCause: new Error('Failed to update prospect lead id'),
              },
            ],
          });
        }

        return createSuccessOperationResult(undefined);
      } catch (error) {
        return createErrorOperationResult({
          errors: [
            {
              code: 'failedToUpdateProspectLeadId',
              rootCause: error as Error,
            },
          ],
        });
      }
    },
  };
}
